import { getGeoData } from 'a_common-folder/services/geo.service';
import { COUNTRY_IMPERIAL_SYSTEM, UNIT_MILLIMETER, LENGTH } from 'a_common-folder/constants';
import phone from 'phone';
const {countries} = require('../../../js-src/components/common/ui-select/countries.json');

let info = {};
let metrical = true;

export const getGeoInformation = () => {
    return getGeoData();
}

export const getCountry = (iosCode) => {
    const index = countries.findIndex(c => c.value == iosCode.toUpperCase());
    const country = countries[index];

    if(country){
        return country.name;
    }else{
        return null;
    }
}

export const getIsoCode = (country_name = info['country_name']) => {
    const index = countries.findIndex(c => c.name == country_name);
    const country = countries[index];

    if(country){
        return country.value
    }else{
        return null;
    }
}

export const getCurrentCountry = () => {
    return new Promise((res, rej) => {
        if(!info['country_name']){
            getGeoInformation().then((responce) => {
                let { data } = responce;
                info = data || {};
                res(info['country_name']);
            })
        }else{
            res(info['country_name']);
        }
    })
}

export const isMetrical = () => {
    return new Promise((res, rej) => {
        if(!info['country_name']){
            getGeoInformation().then((responce) => {
                let { data } = responce;
                info = data || {};
                metrical = !COUNTRY_IMPERIAL_SYSTEM.includes(info['country_name']);
                res(metrical);
            })
        }else{
            res(metrical);
        }
    })
}

export const changeMeasuringSystem = (val) => {
    return metrical = val;
}

export const validatePhoneNumber = (value, isoCode) => {
    return new Promise((res, rej) => {
        const countryName = getCountry(isoCode);
        const arrPhone = phone(value, countryName);

        if(arrPhone.length){
            res({phone: arrPhone[0]});
        }else{
            rej({err: 'invalid phone number'});
        }
    })
}

export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
}
